import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const WarningRound = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 32, height: 32, fill: 'none', ...props.sx }}
    data-testid="warningRoundIcon"
    titleAccess="warning"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3337 16.0001C29.3337 23.3639 23.3641 29.3334 16.0003 29.3334C8.63653 29.3334 2.66699 23.3639 2.66699 16.0001C2.66699 8.63629 8.63653 2.66675 16.0003 2.66675C23.3641 2.66675 29.3337 8.63629 29.3337 16.0001ZM16.0002 23.2001C16.9369 23.2001 17.6963 22.4407 17.6963 21.5039C17.6963 20.5672 16.9369 19.8078 16.0002 19.8078C15.0634 19.8078 14.304 20.5672 14.304 21.5039C14.304 22.4407 15.0634 23.2001 16.0002 23.2001ZM14.304 10.4962C14.304 11.1291 14.3095 17.177 16.0002 17.177C17.6908 17.177 17.6963 11.1291 17.6963 10.4962C17.6963 9.55948 16.9369 8.80008 16.0002 8.80008C15.0634 8.80008 14.304 9.55948 14.304 10.4962Z"
      fill="#FFC425"
    />
  </SvgIcon>
);

export default WarningRound;
